export const cutString = (string, maxlength) => {
    const strCut = (string.length <= maxlength) ? string : string.substr(0, maxlength)+'...'
    return strCut
}